import * as React from "react";

type DropDownContextType = {
  registerItem: (ref: React.RefObject<HTMLDivElement>) => void;
};

const DropDownContext = React.createContext<DropDownContextType | null>(null);
export default DropDownContext;
